import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Dashboard from "@/pages/Dashboard";
import Onboarding from "@/pages/Onboarding";
import Project from "@/pages/Project";
import FlowPage from "@/pages/Flow";
import Timeline from "@/pages/Timeline";
import Settings from "@/pages/Settings";
import { getGithubStatus, listProjects } from "@/lib/api";

function Root() {
  const [decision, setDecision] = useState("loading"); // 'loading' | 'onboard' | 'home' | { project_id }

  useEffect(() => {
    Promise.all([getGithubStatus(), listProjects()])
      .then(([s, p]) => {
        if (!s.connected || (p?.length ?? 0) === 0) {
          setDecision("onboard");
        } else if (p.length === 1) {
          // Habit: drop them straight back into the project
          setDecision({ project_id: p[0].id });
        } else {
          setDecision("home");
        }
      })
      .catch(() => setDecision("onboard"));
  }, []);

  if (decision === "loading") {
    return <div className="min-h-screen flex items-center justify-center text-[#6b7280] text-sm">Trace</div>;
  }
  if (decision === "onboard") return <Navigate to="/onboarding" replace />;
  if (typeof decision === "object" && decision?.project_id) {
    return <Navigate to={`/project/${decision.project_id}`} replace />;
  }
  return <Dashboard />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/project/:projectId" element={<Project />} />
        <Route path="/project/:projectId/flow" element={<FlowPage />} />
        <Route path="/project/:projectId/timeline" element={<Timeline />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
